import { Box, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { CRITICALITY_LEVELS, CRITICALITY_NOT_SET } from "./criticality-config"

export function CriticalityIcon({ criticality }) {
    const config = CRITICALITY_LEVELS[criticality] ?? CRITICALITY_NOT_SET

    return (
        <Tooltip title={config.label}>
            <Box sx={{ width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Iconify icon={config.icon} sx={{ fontSize: 14, color: config.color }} />
            </Box>
        </Tooltip>
    )
}
